import { useSuspenseQuery } from '@apollo/client';
import { useIntl } from 'react-intl';

import type { ProductType } from '@xing-com/crate-common-graphql-types';
import { GetCampaignDocument } from '@xing-com/crate-upsell-graphql';
import type { GetCampaignQuery } from '@xing-com/crate-upsell-graphql';
import { useHost } from '@xing-com/crate-xinglet';

/**
 * this is the same as useCampaign.ts but language is fetched differently
 * we redirect somewhere else when it's the case.
 * @returns {object} { loading, status, product, campaign }
 */
export function useCampaignLoggedOut({
  mid,
  product,
}: {
  mid: string;
  product: ProductType;
}): {
  status: 'SUCCESS' | 'NETWORK_ERROR';

  campaign: GetCampaignQuery['results'] | null;
} {
  const { locale } = useIntl();
  const host = useHost();

  const { error, data } = useSuspenseQuery(GetCampaignDocument, {
    skip: !product || !locale,
    variables: { mid, product, language: locale },
  });

  if (error) {
    console.error('Error in network request:', error);
    return { status: 'NETWORK_ERROR', campaign: null };
  }

  if (!data || !data.results) {
    return host.redirectToLogin();
  }

  return { status: 'SUCCESS', campaign: data.results };
}
